import { createRouter, createWebHistory } from 'vue-router';
// ホーム画面
import HomeView from '../views/home/HomeView.vue';
// ログイン画面
import LoginView from '../views/login/LoginView.vue';
import ReservePlanningConsultationView from '../views/reserve/ReservePlanningConsultationView.vue';
import ReservePlanningSelectionView from '../views/reserve/ReservePlanningSelectionView.vue';
import ReservePlanningServiceView from '../views/reserve/ReservePlanningServiceView.vue';
import ReservePlanningProgramView from '../views/reserve/ReservePlanningProgramView.vue';
import ReservePlanningPersonalView from '../views/reserve/ReservePlanningPersonalView.vue';
import ReservePlanningCounselorView from '../views/reserve/ReservePlanningCounselorView.vue';
import ReservePlanningAgreeView from '../views/reserve/ReservePlanningAgreeView.vue';
import ReservePlanningConfirmView from '../views/reserve/ReservePlanningConfirmView.vue';
import ReservePlanningCompleteView from '../views/reserve/ReservePlanningCompleteView.vue';
import ReserveListView from '../views/reserve/ReserveListView.vue';
import ReserveDetailView from '../views/reserve/ReserveDetailView.vue';
import UserDetailView from '@/views/user/UserDetailView.vue';
import SigninResetApplyView from '../views/signin/SigninResetApplyView.vue';
import SigninResetPasswordView from '../views/signin/SigninResetPasswordView.vue';
import SigninResetCompleteView from '../views/signin/SigninResetCompleteView.vue';
import SigninUseridApplyView from '../views/signin/SigninUseridApplyView.vue';
import SigninUseridCompleteView from '../views/signin/SigninUseridCompleteView.vue';
import SignupApplyView from '../views/signup/SignupApplyView.vue';
import SignupAgreeView from '../views/signup/SignupAgreeView.vue';
import SignupConfirmView from '../views/signup/SignupConfirmView.vue';
import SignupCompleteView from '../views/signup/SignupCompleteView.vue';
import ConsultationWebListView from '../views/consultation/ConsultationWebListView.vue';
// 企業パスワード入力画面
import SetupCompanyView from '../views/setup/SetupCompanyView.vue';
// 利用規定同意画面
import SetupAgreeView from '../views/setup/SetupAgreeView.vue';
// ユーザー情報設定画面
import SetupUserView from '../views/setup/SetupUserView.vue';
// 親権者同意画面
import SetupParentView from '../views/setup/SetupParentView.vue';
// ファイルダウンロード画面
import FileDownloadView from '@/views/file/FileDownloadView.vue';
// エラー画面
import ErrorView from '../views/common/ErrorView.vue';
// メンテナンス画面
import MaintenanceView from '../views/common/MaintenanceView.vue';
// ページが見つかりません画面
import PageNotFoundView from '../views/common/PageNotFoundView.vue';
// Storeでセッション情報を管理する
import { useLoginStore } from '@/stores/login/loginStore';

const routes = [
    {
        // いずれの画面の指定が無い場合。
        path: '/',
        redirect: '/login',
    },
    {
        // ログイン画面
        // 通常ログイン画面
        path: '/login',
        name: 'login',
        component: LoginView,
    },
    {
        // ログイン画面
        // お知らせメールからSSOでログイン画面に遷移した場合。
        path: '/login2',
        name: 'login2',
        component: LoginView,
    },
    {
        // ログイン画面
        // SSOログイン時にリダイレクトでメンテナンスモードに設定されていた場合。
        path: '/login3',
        name: 'login3',
        component: LoginView,
    },
    {
        // パスワードリセットID入力
        path: '/signin/reset/apply',
        name: 'signinResetApply',
        component: SigninResetApplyView,
    },
    {
        // パスワードリセット新パスワード入力
        path: '/signin/reset/password',
        name: 'signinResetPassword',
        component: SigninResetPasswordView,
    },
    {
        // パスワードリセット完了
        path: '/signin/reset/complete',
        name: 'signinResetComplete',
        component: SigninResetCompleteView,
    },
    {
        // ユーザーID通知入力
        path: '/signin/userid/apply',
        name: 'signinUseridApply',
        component: SigninUseridApplyView,
    },
    {
        // ユーザーのID通知完了
        path: '/signin/userid/complete',
        name: 'signinUseridComplete',
        component: SigninUseridCompleteView,
    },
    {
        // サインアップ入力
        path: '/signup/apply',
        name: 'signupApply',
        component: SignupApplyView,
    },
    {
        // サインアップ同意
        path: '/signup/agree',
        name: 'signupAgree',
        component: SignupAgreeView,
    },
    {
        // サインアップ確認
        path: '/signup/confirm',
        name: 'signupConfirm',
        component: SignupConfirmView,
    },
    {
        // サインアップ完了
        path: '/signup/complete',
        name: 'signupComplete',
        component: SignupCompleteView,
    },
    {
        // 企業パスワード入力画面
        path: '/setup/company',
        name: 'setupCompany',
        component: SetupCompanyView,
        meta: { requiresAuth: true },
    },
    {
        // 利用規定同意画面
        path: '/setup/agree',
        name: 'setupAgree',
        component: SetupAgreeView,
        meta: { requiresAuth: true },
    },
    {
        // ユーザー情報設定画面
        path: '/setup/user',
        name: 'setupUser',
        component: SetupUserView,
        meta: { requiresAuth: true },
    },
    {
        // 親権者同意画面
        path: '/setup/parent',
        name: 'setupParent',
        component: SetupParentView,
        meta: { requiresAuth: true },
    },
    {
        // ホーム画面
        path: '/home',
        name: 'home',
        component: HomeView,
        meta: { requiresAuth: true },
    },
    {
        // 予約(相談内容から利用方法等選択)画面
        path: '/reserve/planning/consultation',
        name: 'reserveplanningconsultation',
        component: ReservePlanningConsultationView,
        meta: { requiresAuth: true },
    },
    {
        // 予約(プログラムから利用方法など選択)画面
        path: '/reserve/planning/selection',
        name: 'reserveplanningselection',
        component: ReservePlanningSelectionView,
        meta: { requiresAuth: true },
    },
    {
        // 予約(相談内容からサービス選択)画面
        path: '/reserve/planning/service',
        name: 'reserveplanningservice',
        component: ReservePlanningServiceView,
        meta: { requiresAuth: true },
    },
    {
        // 予約(プログラムからサービス選択)画面
        path: '/reserve/planning/program',
        name: 'reserveplanningprogram',
        component: ReservePlanningProgramView,
        meta: { requiresAuth: true },
    },
    {
        // 予約(割り当てからサービス選択)画面
        path: '/reserve/planning/personal',
        name: 'reserveplanningpersonal',
        component: ReservePlanningPersonalView,
        meta: { requiresAuth: true },
    },
    {
        // 予約(場所日時選択-カレンダー)画面および予約(場所日時選択-アレンジ)画面
        path: '/reserve/planning/counselor',
        name: 'reserveplanningcounselor',
        component: ReservePlanningCounselorView,
        meta: { requiresAuth: true },
    },
    {
        // 予約(規定同意)画面
        path: '/reserve/planning/agree',
        name: 'reserveplanningagree',
        component: ReservePlanningAgreeView,
        meta: { requiresAuth: true },
    },
    {
        // 予約(予約確認)画面
        path: '/reserve/planning/confirm',
        name: 'reserveplanningconfirm',
        component: ReservePlanningConfirmView,
        meta: { requiresAuth: true },
    },
    {
        // 予約(予約完了)画面
        path: '/reserve/planning/complete',
        name: 'reserveplanningcomplete',
        component: ReservePlanningCompleteView,
        meta: { requiresAuth: true },
    },
    {
        // 予約一覧画面
        path: '/reserve/list',
        name: 'reservelist',
        component: ReserveListView,
        meta: { requiresAuth: true },
    },
    {
        // 予約詳細画面
        path: '/reserve/detail',
        name: 'reservedetail',
        component: ReserveDetailView,
        meta: { requiresAuth: true },
    },
    {
        // Web相談一覧
        path: '/consultation/web/list',
        name: 'consultationWebList',
        component: ConsultationWebListView,
        meta: { requiresAuth: true },
    },
    {
        // ユーザー情報確認画面
        path: '/user/detail',
        name: 'userDetail',
        component: UserDetailView,
        meta: { requiresAuth: true },
    },
    {
        // ファイルダウンロード画面
        path: '/file/download',
        name: 'fileDownload',
        component: FileDownloadView,
        meta: { requiresAuth: true },
    },
    {
        // エラー画面
        path: '/error',
        name: 'error',
        component: ErrorView,
    },
    {
        // メンテナンス画面
        path: '/maintenance',
        name: 'maintenance',
        component: MaintenanceView,
    },
    {
        // メンテナンス画面
        path: '/pageNotFound',
        name: 'pageNotFound',
        component: PageNotFoundView,
    },
    {
        // 上記のURLいずれにもマッチしない場合。
        path: '/:pathMatch(.*)*',
        redirect: '/pageNotFound',
    },
];

// ルーターを生成
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.beforeEach(async (to, from, next) => {
    const loginStore = useLoginStore();
    const token = await loginStore.isTokenValid();
    // 現在いる画面、もしくは、移動先の画面が、ログイン権限が必要な画面で、かつ、有効なCognitoのセッショントークンが発行されている場合。
    if (to.matched.some((record) => record.meta.requiresAuth) && !token) {
        // Cognitoログアウト処理
        await loginStore.cognitoLogoutAction();
        //next({ path: 'login', query: { vid: loginStore.getVendorId } });
    } else {
        // 有効なCognitoのセッショントークンが存在する場合や、遷移先の画面がログイン権限不要な場合。
        next();
    }
});
export default router;
